export default function MarkAuditCompleteConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  editAuditDialog,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.appLoaded = false;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveAuditDialog = _handleSaveAuditDialog;
  vm.handleCompleteAuditDialog = _handleCompleteAuditDialog;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    if (vm.audit.auditId > 0) {
      return $q.all([
        amDataService.getPreparationItemsByAuditAndStatuses(vm.audit.auditId, '1,2'),
        amDataService.getFindingsByAuditAndStatuses(vm.audit.auditId, '1,2'),
      ]).then((results) => {
        vm.numIncompletePreparationItems = results[0].data.result.length;
        vm.numIncompleteFindings = results[1].data.result.length;
        vm.appLoaded = true;
        loaderService.showViewLoader = false;
      });
    }
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.markAuditCompleteConfirmDialog);
  }

  function _handleSaveAuditDialog() {
    const dfdRefresh = $q.defer();

    amDataService.saveAudit(vm.audit).then((savedAuditResponse) => {
      const savedAudit = savedAuditResponse.data.result;
      if (savedAudit.auditId === 'undefined' || savedAudit.auditId <= 0) {
        // There was an error saving the audit information
        alerts.error('An error occurred while saving the Audit.');
        dfdRefresh.reject();
      } else {
        // The audit information has been saved
        vm.audit.auditId = savedAudit.auditId;
        alerts.success('The Audit has been successfully saved.');
        ssDialogService.hide(ssDialogService.dialogs.auditTrail.markAuditCompleteConfirmDialog);
        ssDialogService.hide(ssDialogService.dialogs.auditTrail.editAuditDialog)
          .then(dfdRefresh.resolve);
        $rootScope.$broadcast('refreshAMAudits');
        $rootScope.$broadcast('refreshNotifications');
      }
    });

    return dfdRefresh.promise;
  }

  function _handleCompleteAuditDialog() {
    const dfdRefresh = $q.defer();

    amDataService.completeAudit(vm.audit.auditId).then((response) => {
      const savedAudit = response.data;
      if (savedAudit.auditId === 'undefined' || savedAudit.auditId <= 0) {
        // There was an error saving the audit information
        alerts.error('An error occurred while completing the Audit.');
        dfdRefresh.reject();
      } else {
        // The audit information has been saved
        vm.audit.auditId = savedAudit.auditId;
        alerts.success('The Audit has been successfully completed.');
        ssDialogService.hide(ssDialogService.dialogs.auditTrail.markAuditCompleteConfirmDialog)
          .then(dfdRefresh.resolve);
        $rootScope.$broadcast('closeEditAudit');
        $rootScope.$broadcast('refreshAMAudits');
        $rootScope.$broadcast('refreshNotifications');
      }
    });

    return dfdRefresh.promise;
  }
}

MarkAuditCompleteConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'editAuditDialog',
  'loaderService',
  'ssDialogService'
];
